import { render, staticRenderFns } from "./info-stats.vue?vue&type=template&id=a70a5454"
import script from "./info-stats.vue?vue&type=script&lang=ts"
export * from "./info-stats.vue?vue&type=script&lang=ts"
import style0 from "./info-stats.vue?vue&type=style&index=0&id=a70a5454&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports